import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useI18n } from '../i18n';
import PageHero from '../components/PageHero';
import { SectionWrap, SectionHeader, Bullets, Prose } from '../components/SectionPrimitives';

import { VIDAT_IMG } from '../lib/images';

const IMG = VIDAT_IMG.monasterio2;

const TRAJECTORY_LABEL = { es: 'Trayectoria', ca: 'Trajectòria' };

const TeamCard = ({ member, index, lang }) => {
  const [open, setOpen] = useState(index === 0);
  return (
    <article className="border-t border-[#0936F6]/30 py-8" data-testid={`team-card-${index}`}>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-4">
          <div className="font-mono text-xs tracking-widest text-cyan-vidat mb-3">0{index + 1}</div>
          <h3 className="display-md text-cyan-vidat" data-testid={`team-name-${index}`}>{member.name}</h3>
          <div className="text-sm text-stone-600 font-light mt-2 max-w-xs leading-relaxed">{member.role}</div>
        </div>
        <div className="lg:col-span-8">
          <button
            onClick={() => setOpen(!open)}
            className="acc-trigger"
            data-open={open}
            data-testid={`team-toggle-${index}`}
          >
            <span>{open ? '—' : '+'} {TRAJECTORY_LABEL[lang] || TRAJECTORY_LABEL.es}</span>
            <ChevronDown size={18} className={`transition-transform ${open ? 'rotate-180' : ''}`} strokeWidth={1.5} />
          </button>
          {open && (
            <div className="acc-content space-y-3" data-testid={`team-bio-${index}`}>
              {member.bio.map((p, i) => (<p key={i}>{p}</p>))}
            </div>
          )}
        </div>
      </div>
    </article>
  );
};

const SUBTITLE = {
  es: 'Tres direcciones, una visión común',
  ca: 'Tres direccions, una visió comuna',
};

const SobreVidat = () => {
  const { content, lang } = useI18n();
  const a = content.about;
  return (
    <main data-testid="about-page">
      <PageHero eyebrow={a.eyebrow} title={a.title} image={IMG} testId="about-hero" />

      <SectionWrap bg="ivory" testId="about-intro">
        <Prose paragraphs={[a.p1, a.p2, a.p3]} />
      </SectionWrap>

      <SectionWrap testId="about-team">
        <SectionHeader eyebrow={a.teamEyebrow} title={SUBTITLE[lang] || SUBTITLE.es} />
        <div className="mt-4">
          {a.team.map((m, i) => (<TeamCard key={i} member={m} index={i} lang={lang} />))}
        </div>
      </SectionWrap>

      <SectionWrap bg="ivory" testId="about-collab">
        <SectionHeader title={a.collabTitle} />
        <Prose paragraphs={[a.collabP1, a.collabP2]} />
        <p className="mt-6 text-stone-700 font-light">{a.collabIntro}</p>
        <div className="mt-6"><Bullets items={a.collabList} /></div>
        <p className="mt-8 text-stone-700 font-light max-w-3xl leading-relaxed">{a.collabOutro}</p>
      </SectionWrap>

      <SectionWrap testId="about-method">
        <SectionHeader title={a.methodTitle} />
        <Prose paragraphs={[a.methodP1, a.methodP2]} />
        <div className="mt-8"><Bullets items={a.methodList} /></div>
        <p className="mt-8 text-stone-700 font-light max-w-3xl leading-relaxed">{a.methodOutro}</p>
      </SectionWrap>

      <SectionWrap bg="ivory" testId="about-vision">
        <SectionHeader title={a.visionTitle} />
        <Prose paragraphs={[a.visionP1, a.visionP2, a.visionP3, a.visionP4, a.visionP5]} />
      </SectionWrap>

    </main>
  );
};

export default SobreVidat;
